<div class="d-flex flex-column pt-medium">
  <div class="pb-medium">
    <common-user-assets-assets-slider></common-user-assets-assets-slider>
  </div>
  <div
    class="pb-plus px-plus search-container surface-back"
    commonUtilitiesStickyObserver
  >
    <common-ui-components-search
      [readOnlyMode]="true"
      [placeHolder]="'جستجو در خدمات'"
      (clicked)="gotoSearch()"
    ></common-ui-components-search>
  </div>
  <div class="px-plus">
    <payment-transactions-upcoming-transactions-summary
      [types]="['installment']"
      [title]="'اقساط پیش‌رو'"
      class="d-block mb-big"
      [hideAllButton]="true"
    ></payment-transactions-upcoming-transactions-summary>
  </div>

  <common-app-banners-shared-common-banners
    [bannersData]="bannersData()"
    [categoryToShow]="BannerCategory.HUB_1"
  >
  </common-app-banners-shared-common-banners>

  <div class="px-plus py-big">
    <common-app-services-selected-services-preview
      [services]="services()"
      [isLoading]="servicesLoading()"
    ></common-app-services-selected-services-preview>
  </div>

  @defer (on viewport) {
    <common-app-services-grouped-app-services
      [category]="appServicesCategoriesConst[AppServiceCategoryNamesEnum.PAY]"
      [services]="services()"
      [isLoading]="servicesLoading()"
    ></common-app-services-grouped-app-services>
    <common-app-banners-shared-common-banners
      class="mb-medium"
      [bannersData]="bannersData()"
      [categoryToShow]="BannerCategory.HUB_2"
    >
    </common-app-banners-shared-common-banners>
  } @placeholder (minimum 1000ms) {
    <div class="px-plus py-big">
      <lib-ngx-skeleton-loading
        [height]="'300px'"
        [classes]="'radius-medium'"
        [width]="'100%'"
      ></lib-ngx-skeleton-loading>
    </div>
  }

  @defer (on viewport) {
    <common-app-banners-shared-common-banners
      [bannersData]="bannersData()"
      [categoryToShow]="BannerCategory.HUB_3"
    >
    </common-app-banners-shared-common-banners>
    <common-app-services-grouped-app-services
      [category]="appServicesCategoriesConst[AppServiceCategoryNamesEnum.MOBILE]"
      [services]="services()"
      [isLoading]="servicesLoading()"
    ></common-app-services-grouped-app-services>
  } @placeholder (minimum 2000ms) {
    <div class="px-plus py-big">
      <lib-ngx-skeleton-loading
        [height]="'300px'"
        [classes]="'radius-medium'"
        [width]="'100%'"
      ></lib-ngx-skeleton-loading>
    </div>
  }
  @defer (on viewport) {
    <common-app-banners-shared-common-banners
      [bannersData]="bannersData()"
      [categoryToShow]="BannerCategory.HUB_4"
    >
    </common-app-banners-shared-common-banners>
    <common-app-services-grouped-app-services
      [category]="appServicesCategoriesConst[AppServiceCategoryNamesEnum.WEALTH]"
      [services]="services()"
      [isLoading]="servicesLoading()"
    ></common-app-services-grouped-app-services>
    <common-app-banners-shared-common-banners
      [bannersData]="bannersData()"
      [categoryToShow]="BannerCategory.HUB_5"
    >
    </common-app-banners-shared-common-banners>
    <common-app-services-grouped-app-services
      [category]="appServicesCategoriesConst[AppServiceCategoryNamesEnum.INSURANCE]"
      [services]="services()"
      [isLoading]="servicesLoading()"
    ></common-app-services-grouped-app-services>
  } @placeholder (minimum 3000ms) {
    <div class="px-plus py-big">
      <lib-ngx-skeleton-loading
        [height]="'300px'"
        [classes]="'radius-medium'"
        [width]="'100%'"
      ></lib-ngx-skeleton-loading>
    </div>
  }

  @defer (on viewport) {
    <common-app-banners-shared-common-banners
      [bannersData]="bannersData()"
      [categoryToShow]="BannerCategory.HUB_6"
    >
    </common-app-banners-shared-common-banners>
    <common-app-services-grouped-app-services
      [category]="appServicesCategoriesConst[AppServiceCategoryNamesEnum.VEHICLE]"
      [services]="services()"
      [isLoading]="servicesLoading()"
    ></common-app-services-grouped-app-services>
    <div class="px-plus">
      <hub-applet-bill-services [billServiceData]="billService()"></hub-applet-bill-services>
    </div>
    <div class="py-big px-plus">
      <hub-applet-charity-services></hub-applet-charity-services>
    </div>

    <common-app-banners-shared-common-banners
      [bannersData]="bannersData()"
      [categoryToShow]="BannerCategory.HUB_7"
    >
    </common-app-banners-shared-common-banners>
  } @placeholder (minimum 4000ms) {
    <div class="px-plus py-big">
      <lib-ngx-skeleton-loading
        [height]="'300px'"
        [classes]="'radius-medium'"
        [width]="'100%'"
      ></lib-ngx-skeleton-loading>
    </div>
  }
</div>
